const value = {
  title: 'Analytics',
  noResults: 'Nothing here yet',
  noResultsMessage: 'Chart with data will appear here soon',
  resultsByProject: 'Learning progress by projects',
  exportReports: 'Export reports',
  exportEmployeesReport: 'Report by users',
  exportUnitsReport: 'Report by units',
  exportProjectReport: 'Export project report',
  exportUserReport: 'Export report',
  employees: 'Employees',
  notStarted: 'Not started',
  inProgress: 'In progress',
  completed: 'Completed',
  ratingTitle: 'Leaderboard:',
  projects: 'Projects',
  users: 'Users',
  userUnitProgress: 'Unit Progress',
  userUnitStatuses: {
    notStarted: 'New',
    inProgress: 'In progress',
    completed: 'Completed',
    failed: 'Failed',
  },
  ratings: {
    noData: 'No data',
    rowsPerPage: 'Rows per page:',
    of: 'of',
    nextPage: 'Next page',
    previousPage: 'Previous page',
    projects: {
      name: 'Name',
      averageProgress: 'Unit progress',
      usersCount: 'Users',
      averageScore: 'Score',
      searchPlaceholder: 'Search by project name',
    },
    users: {
      userName: 'User',
      projectRoles: 'Roles',
      projects: 'Projects',
      progress: 'Unit progress',
      score: 'Score',
      unitsPassed: 'Units passed',
      searchPlaceholder: 'Search by user name',
    },
  },
  metricsHistory: {
    title: 'Metrics History',
    userTitle: 'Progress History',
    createSnapshot: 'Create Snapshot',
    noData: 'No history data available',
    tabs: {
      averageProgress: 'Avg. Progress',
      averageScore: 'Avg. Score',
      activeUsers: 'Active Users',
      completedUsers: 'Completed Users',
    },
    userTabs: {
      importantScore: 'Score',
      progressPercent: 'Progress',
    },
  },
};

export default value;
